// extracted by mini-css-extract-plugin
export var circle = "_br-1";
export var exitConfirmationModal = "_br-5";
export var iframe = "_br-0";
export var offline = "_br-3";
export var online = "_br-2";
export var workstationSelectError = "_br-4";